// extracted by mini-css-extract-plugin
export var fullGrid = "_39-3";
export var pdpPreviewContainer = "_39-1";
export var previewContainer = "_39-0";
export var togglePreviewContainer = "_39-2";